<div class="modal-header">
  <h2 class="modal-title mb-0 fs-3 fw-bold" *ngIf="hasTitle">
    {{ title | translate }}
  </h2>
  <button type="button" class="btn-close" (click)="bsModalRef.hide()" [attr.aria-label]="'button.close' | translate"></button>
</div>
<div class="modal-body">
  <p class="text-center">{{ message | translate: translationParams }}</p>
</div>
<div class="modal-footer justify-content-between">
  <button (click)="cancel()" class="btn btn-outline-primary">
    {{ 'button.cancel' | translate }}
  </button>
  <button (click)="confirm()" class="btn btn-primary">
    {{ 'button.confirm' | translate }}
  </button>
</div>
